import closeIcon from 'assets/icons/close.svg';
import { CopyInput } from 'components/Input';
import Text from 'components/Text';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Toggle } from '../newSkin/Toggle/Toggle';
import SocialIcons from './SocialIcons';

import {
  Overlay,
  ShareByTimeWrap,
  ShareWidgetStyled,
  ShareWrapper,
  SocialWrap,
  StyledButton,
  StyledTitle,
} from './styles/ShareWidgetStyled';
import { playerMethods } from '../../initSkin';

const ShareWidget = ({
  translate,
  socials = [],
  onClose,
  onShareLinkByTimeChanged,
  shareLink,
  translateKeys,
  canBeSharedByTime,
  canBeSharedByTimeSelected,
}) => {
  const shareText = translate(translateKeys.watchOnMgg);

  return (
    <ShareWidgetStyled>
      <Overlay onClick={onClose} />
      <ShareWrapper>
        <StyledButton
          hoverColor="gray_nightrider"
          iconFill="gray_mediumlight"
          icon={closeIcon}
          size="small"
          iconSize={36}
          onClick={onClose}
          data-role="closeButton"
        />
        <StyledTitle font="inherit" weight="450">
          {translate(translateKeys.shareButton)}
        </StyledTitle>
        <CopyInput
          titleText={translate(translateKeys.linkFromVideoText)}
          copyText={translate(translateKeys.copyTextButton)}
          copiedText={translate(translateKeys.copied)}
          text={shareLink}
          textFont="inherit"
          textWeight="500"
          textSize="fs_s"
          readOnly
          fixedTextSize
          inputTextSize="fs_l"
          inputTextWeight="500"
          onCopyButtonClick={playerMethods.onShareWidgetCopyButtonClick}
        />
        {canBeSharedByTime && (
          <ShareByTimeWrap>
            <Toggle
              value={canBeSharedByTimeSelected}
              onChange={onShareLinkByTimeChanged}
            />
            <Text
              fixedSize
              size="fs_md"
              font="inherit"
              weight="500"
              type="uppercase"
              color="gray_nightrider"
            >
              {translate(translateKeys.shareFromSocialTextByTime)}
            </Text>
          </ShareByTimeWrap>
        )}
        {Boolean(socials.length) && (
          <SocialWrap>
            <Text
              fixedSize
              size="fs_s"
              font="inherit"
              weight="500"
              color="gray_nightrider"
            >
              {translate(translateKeys.shareFromSocialText)}
            </Text>
            <SocialIcons
              socials={socials}
              shareLink={shareLink}
              shareText={shareText}
            />
          </SocialWrap>
        )}
      </ShareWrapper>
    </ShareWidgetStyled>
  );
};

ShareWidget.propTypes = {
  translate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onShareLinkByTimeChanged: PropTypes.func.isRequired,
  shareLink: PropTypes.string.isRequired,
  socials: PropTypes.array.isRequired,
  translateKeys: PropTypes.object.isRequired,
  canBeSharedByTime: PropTypes.bool,
  canBeSharedByTimeSelected: PropTypes.bool,
};

ShareWidget.defaultProps = {
  canBeSharedByTime: false,
  canBeSharedByTimeSelected: false,
};

export default memo(ShareWidget);
